import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import Logo from "../../assets/g8.png";
import "./Navbar.css";

const COLLECTION_LINKS = [
  { name: "Pergola Systems",    link: "/collections/pergolas" },
  { name: "Partition Systems",  link: "/collections/partitions" },
  { name: "Door Systems",       link: "/collections/doors" },
  { name: "Sliding Systems",    link: "/collections/sliders" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  const closeMobileMenu = () => setOpen(false);

  const isActive = (path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <nav className="frosted-nav" aria-label="Primary">
      <div className="nav-inner flex items-center font-medium text-white">
        {/* Brand */}
        <div className="nav-brand z-50 flex items-center justify-between w-full md:w-auto py-4 md:py-0">
          <Link to="/">
            <img src={Logo} alt="Astra Concepts" className="md:cursor-pointer h-12 logo-mark" />
          </Link>
          <button
            type="button"
            className="text-3xl md:hidden text-white"
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation"
          >
            {open ? <HiX /> : <HiMenu />}
          </button>
        </div>

        {/* Desktop nav */}
        <div className="nav-desktop hidden md:flex flex-1 justify-center">
          <ul className="uppercase flex items-center gap-4 lg:gap-6 xl:gap-8 font-[Poppins] tracking-[0.15em] text-xs lg:text-sm">
            <li>
              <Link to="/" className={`navbar-link py-7 px-2 lg:px-3 inline-block transform transition duration-200 hover:scale-110${isActive("/") ? " active" : ""}`}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className={`navbar-link py-7 px-2 lg:px-3 inline-block transform transition duration-200 hover:scale-110${isActive("/about") ? " active" : ""}`}>
                About
              </Link>
            </li>

            {/* Collections dropdown — hover only, no page link */}
            <li
              className="relative"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <span
                className={`navbar-link navbar-link--trigger py-7 px-2 lg:px-3 inline-block${isActive("/collections") ? " active" : ""}`}
              >
                Collections
              </span>
              {dropdownOpen && (
                <div className="nav-dropdown">
                  <p className="nav-dropdown__label">Our Systems</p>
                  {COLLECTION_LINKS.map((item) => (
                    <Link
                      key={item.link}
                      to={item.link}
                      className="nav-dropdown__link"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              )}
            </li>

            <li>
              <Link to="/projects" className={`navbar-link py-7 px-2 lg:px-3 inline-block transform transition duration-200 hover:scale-110${isActive("/projects") ? " active" : ""}`}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="/contact" className={`navbar-link py-7 px-2 lg:px-3 inline-block transform transition duration-200 hover:scale-110${isActive("/contact") ? " active" : ""}`}>
                Contact Us
              </Link>
            </li>
            <li>
              <a
                href="https://varsa.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-link py-7 px-3 inline-block transform transition duration-200 hover:scale-110"
              >
                Varsa
              </a>
            </li>
            <li>
              <a
                href="https://instagram.com/astraconcepts.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-link flex items-center gap-2 py-7 px-3 text-sm"
              >
                <FaInstagram className="text-lg" />
                Instagram
              </a>
            </li>
          </ul>
        </div>

        {/* Mobile nav panel */}
        <ul
          className={`mobile-nav-panel md:hidden z-50 text-left text-white ${open ? "is-open" : ""}`}
        >
          <li className="mobile-nav-close-row">
            <button
              type="button"
              className="mobile-nav-close"
              onClick={() => setOpen(false)}
              aria-label="Close menu"
            >
              <span>Close</span>
              <HiX />
            </button>
          </li>
          <li>
            <Link to="/" className="py-7 px-3 inline-block" onClick={closeMobileMenu}>Home</Link>
          </li>
          <li>
            <Link to="/about" className="py-7 px-3 inline-block" onClick={closeMobileMenu}>About</Link>
          </li>
          <li className="mobile-nav-section-label">Collections</li>
          {COLLECTION_LINKS.map((item) => (
            <li key={item.link} className="pl-4">
              <Link to={item.link} className="py-3 px-3 inline-block text-xs tracking-widest opacity-70" onClick={closeMobileMenu}>
                {item.name}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/projects" className="py-7 px-3 inline-block" onClick={closeMobileMenu}>Projects</Link>
          </li>
          <li>
            <Link to="/contact" className="py-7 px-3 inline-block" onClick={closeMobileMenu}>Contact Us</Link>
          </li>
          <li>
            <a
              href="https://varsa.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="py-7 px-3 inline-block"
              onClick={closeMobileMenu}
            >
              Varsa
            </a>
          </li>
          <li>
            <a
              href="https://instagram.com/astraconcepts.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="py-7 px-3 inline-block flex items-center gap-2"
              onClick={closeMobileMenu}
            >
              <FaInstagram className="text-xl" />
              Instagram
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
